import { Dayjs } from 'dayjs';

import { getPresetRange, type DateRangePresetLabel } from '@prerender/design-system/DateRangePicker';

/**
 * The one fixed reporting window every Search Performance widget is scoped
 * to (PRD: fixed, not selectable, up to 30 days). The filter row displays it
 * and the KPI query sends it — both through this helper, so the window shown
 * and the window queried can never drift. The real, data-bounded date filter
 * lands with PRE-2625.
 */
export const REPORTING_WINDOW_PRESET: DateRangePresetLabel = 'last 30 days';

export type ReportingWindow = {
  from: Dayjs;
  end: Dayjs;
  /** `from` in the API's YYYY-MM-DD query-param format. */
  dateStart: string;
  /** `end` in the API's YYYY-MM-DD query-param format. */
  dateEnd: string;
};

/**
 * Resolve per render, not once at module load: a tab left open past midnight
 * would otherwise keep showing (and querying) yesterday's window.
 */
export function getReportingWindow(): ReportingWindow {
  const { from, end } = getPresetRange(REPORTING_WINDOW_PRESET);
  return {
    from,
    end,
    dateStart: from.format('YYYY-MM-DD'),
    dateEnd: end.format('YYYY-MM-DD'),
  };
}
